import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageHeaderComponent } from 'src/app/Core/pageheader.component';
import { Page } from './DocumentCategoryDetail.component';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { DocumentCategoryService } from 'src/app/API/documentcategory.service';

@Component({
  selector: 'DocumentCategorySearch',
  templateUrl: './DocumentCategorySearch.component.html'
})
export class DocumentCategorySearchComponent implements OnInit {
 
  ShowSearch = false;
  searchText = 'Search Records';
  selectedDivision ='';
  blnDirtySearch = false;
  DialysisUnits = [];

  constructor(public dialog: MatDialog, private router: Router, private documentCategoryService: DocumentCategoryService) { }

  @ViewChild(PageHeaderComponent, { static: true }) pageheader: PageHeaderComponent;
    loading = true;
    tableHeaders;
    page = new Page();
    rows = [];
    AddUrl = '/Admin/DocumentCategoryDetail';
    currentPageNumber = 1;
    sortExpression = 'documentcategory';
    sortDirection = 'ASC';
    pageSize = 25;
    title = 'Document Category';
    defaultSort;

    // get documentCategories() {
    //   return this.documentCategoryService.getCategories().map(cat => ({ value: cat, text: cat }));
    // }

    selectedCategory: string = '';
  
  ngOnInit() {
    this.loadData();
  }

  loadData() {
    // const allData = this.documentCategoryService.getCategories().map((cat, idx) => ({ id: idx + 1, name: cat }));
    // this.page.totalElements = allData.length;
    // this.page.totalPages = Math.ceil(this.page.totalElements / this.pageSize);
    
    // // Calculate start and end index for current page
    // const startIndex = (this.currentPageNumber - 1) * this.pageSize;
    // const endIndex = Math.min(startIndex + this.pageSize, this.page.totalElements);
    // this.rows = allData.slice(startIndex, endIndex);

        AppComponent.ShowLoader();
        const DocumentCategorySearch = this.prepareSearch();
        this.documentCategoryService.GetDocumentCategoryList(DocumentCategorySearch).subscribe(pagedData  => {
            this.page.totalElements = pagedData.totalRows;
            this.page.totalPages = pagedData.totalPages;
            this.rows = pagedData.documentCategoryDetails;
            AppComponent.HideLoader();
          }
        ,
        error => {
              AppComponent.addAlert(error.message, 'error');
              AppComponent.HideLoader();
          }
        );
  }

  ngAfterViewChecked() {
    
  }

  onSearchShowChange(value) {
    this.ShowSearch = value;
  }

  // executeDesignationSearch() {
  //   this.currentPageNumber = 1;
  //   const filteredData = this.selectedCategory ? 
  //     this.documentCategoryService.getCategories()
  //       .filter(cat => cat === this.selectedCategory)
  //       .map((cat, idx) => ({ id: idx + 1, name: cat }))
  //     : this.documentCategoryService.getCategories()
  //       .map((cat, idx) => ({ id: idx + 1, name: cat }));

  //   this.page.totalElements = filteredData.length;
  //   this.page.totalPages = Math.ceil(this.page.totalElements / this.pageSize);
  //   this.rows = filteredData.slice(0, this.pageSize);
  // }
   
  setPage() {
    this.currentPageNumber = this.page.pageNumber;
    this.loadData();
  }

  executeDesignationSearchClear() {
    this.selectedCategory = '';
    this.currentPageNumber = 1;
    this.loadData();
  }

   _onRowClick(row) {
    this.router.navigate([this.AddUrl], { queryParams: { id: row } });
  }

  prepareSearch() {
  // tslint:disable-next-line:prefer-const
  let TaskTypesearch = <any>{};
  TaskTypesearch.currentPageNumber = this.currentPageNumber;
  TaskTypesearch.sortExpression = this.sortExpression;
  TaskTypesearch.sortDirection = this.sortDirection;
  TaskTypesearch.PageSize = this.pageSize;
   // console.log(TaskTypesearch);
  return TaskTypesearch;
}
}
